/** Versión de marca: súbela al cambiar favicon/logo en /public para invalidar caché. */
export const BRAND_ASSET_VERSION = '20260709';

const withVersion = (path) => `${path}?v=${BRAND_ASSET_VERSION}`;

export const BRAND_LOGO_512_URL = withVersion('https://e-asy.es/logo512.png');
export const BRAND_LOGO_192_URL = withVersion('https://e-asy.es/logo192.png');
export const BRAND_LOGO_512_PATH = withVersion('/logo512.png');
